import {
  ReferenceInput,
  ReferenceArrayInput,
  SelectInput,
  SelectArrayInput,
  ReferenceField,
  ReferenceArrayField,
  TextField,
  FunctionField,
  ChipField,
  SingleFieldList,
} from 'react-admin';
import { useCourseIds } from '../utils/useCourseIds';

// --- Input Components ---

export const CourseIdSelect = (props: any) => {
  const course_ids = useCourseIds();
  return (
    <CourseSelect
      {...props}
      filter={course_ids ? { id: course_ids } : undefined}
    />
  );
};

export const CourseSelect = (props: any) => (
  <ReferenceInput
    label="Course"
    source="course_id"
    sort={{ field: 'name', order: 'ASC' }}
    reference="courses"
    {...props}
  >
    <SelectInput optionText="name" />
  </ReferenceInput>
);

export const CoursesSelect = (props: any) => (
  <ReferenceArrayInput
    sort={{ field: 'name', order: 'ASC' }}
    label="Courses"
    source="course_ids"
    reference="courses"
    {...props}
  >
    <SelectArrayInput optionText="name" />
  </ReferenceArrayInput>
);

export const AssessmentSelect = (props: any) => (
  <ReferenceInput
    sort={{ field: 'name', order: 'ASC' }}
    label="Assessment"
    source="assessment_id"
    reference="assessments"
    perPage={100}
    {...props}
  >
    <SelectInput optionText="name" />
  </ReferenceInput>
);

export const AssignmentSelect = (props: any) => (
  <ReferenceInput
    sort={{ field: 'name', order: 'ASC' }}
    label="Assignment"
    source="assignment_id"
    reference="assignments"
    perPage={100}
    {...props}
  >
    <SelectInput optionText="name" />
  </ReferenceInput>
);

export const ClassSelect = (props: any) => (
  <ReferenceInput
    sort={{ field: 'name', order: 'ASC' }}
    label="Class"
    source="student_group_id"
    reference="student_groups"
    perPage={100}
    {...props}
  >
    <SelectInput optionText="name" />
  </ReferenceInput>
);

export const EventSelect = (props: any) => (
  <ReferenceInput
    sort={{ field: 'name', order: 'ASC' }}
    label="Event"
    source="event_id"
    reference="events"
    perPage={100}
    {...props}
  >
    <SelectInput optionText="name" />
  </ReferenceInput>
);

export const StudentSelect = (props: any) => (
  <ReferenceInput
    sort={{ field: 'last_name', order: 'ASC' }}
    label="Student"
    source="student_id"
    reference="students"
    perPage={100}
    {...props}
  >
    <SelectInput optionText={getFullName} />
  </ReferenceInput>
);

export const StudentGroupSelect = (props: any) => (
  <ReferenceInput
    sort={{ field: 'name', order: 'ASC' }}
    label="Class"
    source="student_group_id"
    reference="student_groups"
    perPage={100}
    {...props}
  >
    <SelectInput optionText="name" />
  </ReferenceInput>
);

// --- Display Components ---

export const StudentGroupField = (props: any) => (
  <ReferenceField
    source="student_group_id"
    reference="student_groups"
    label="Class"
    {...props}
  >
    <TextField source="name" />
  </ReferenceField>
);

export const CourseField = (props: any) => (
  <ReferenceField
    source="course_id"
    reference="courses"
    label="Course"
    {...props}
  >
    <TextField source="name" />
  </ReferenceField>
);

export const CoursesField = (props: any) => (
  <ReferenceArrayField
    source="course_ids"
    reference="courses"
    label="Courses"
    {...props}
  >
    <SingleFieldList>
      <ChipField source="name" />
    </SingleFieldList>
  </ReferenceArrayField>
);

export const EventField = (props: any) => (
  <ReferenceField
    source="event_id"
    reference="events"
    label="Event"
    {...props}
  >
    <TextField source="name" />
  </ReferenceField>
);

export const AssessmentField = (props: any) => (
  <ReferenceField
    source="assessment_id"
    reference="assessments"
    label="Assessment"
    {...props}
  >
    <TextField source="name" />
  </ReferenceField>
);

export const StudentField = (props: any) => (
  <ReferenceField
    source="student_id"
    reference="students"
    label="Student"
    {...props}
  >
    <FullNameField />
  </ReferenceField>
);

export const AssignmentField = (props: any) => (
  <ReferenceField
    source="assignment_id"
    reference="assignments"
    label="Assignment"
    {...props}
  >
    <TextField source="name" />
  </ReferenceField>
);

// --- Utility Components ---

export const FullNameField = (props: any) => (
  <FunctionField {...props} render={getFullName} />
);

export const getFullName = (s: any): string =>
  s ? `${s.last_name}, ${s.first_name} ${s.middle_initial || 'X'}` : '';

export const ArchivedSelect = (props: any) => (
  <SelectInput
    source="archived_at"
    label="Show Archived"
    alwaysOn
    defaultValue={0}
    choices={[
      { id: 0, name: 'No' },
      { id: 1, name: 'Yes' },
    ]}
    {...props}
  />
);
